import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { DatePipe } from '@angular/common';
import { chemistmasterdata } from '../../model';
import { TPdeviationReportModel } from '../../model'
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../exceldownloader';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 
@Component({
  selector: 'app-expensestatement',
  template: require('./expensestatement.component.html'),
  styles: []
})
export class ExpenseStatementComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowHeight;
  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;
  private rowData;
  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;
  headQuarterList: any = [];
  stateList: any = [];
  token: any;
  api2: any;
  columnApi2: any;
  private EmpcolumnDefsExport;
  chemistmasterdataModel: chemistmasterdata = new chemistmasterdata();
  static parameters = [ApiService, Router, HttpClient, ToastrService, ExcelService]
  constructor(
      private apiService: ApiService, private router: Router, private http: HttpClient, private toast: ToastrService, private ExcelService: ExcelService

  ) {
    this.columnDefs = [
      // { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
      {
        headerName: 'Emp. Name', field: "Client_Name", suppressFilter: true, cellRenderer: 'agGroupCellRenderer'
      },
      { headerName: 'Emp. Code', field: "Client_Code" },
      { headerName: 'Staff Type', field: "ClientTypeDesc" },
      { headerName: 'HQ', field: "HQName" },
      { headerName: 'State', field: "State" },
      { headerName: 'Claimed Expense', field: "claimedExpense" },
      { headerName: 'Passed Expense', field: "PassedExpense" },
    ];
    this.EmpcolumnDefsExport = [
      { headerName: 'Employee Code', field: 'Client_Code' },
      {
        field: 'Date'
      },
      { field: 'ActualStation' },
      {
        field: 'WorkingRoute',
        minWidth: 150,
      },
      {
        field: 'DAType'
      },
      {
        field: 'Work With'
      },
      {
        field: 'Call'
      },
      // {
      //   field: 'Mode'
      // },
      {
        field: 'KM'
      },
      {
        field: 'Fare (TA)'
      },
      {
        field: 'HQ/Ex/Out Station'
      },
      {
        field: 'OtherExpense'
      },
      {
        field: 'Total'
      },
      {
        field: 'Remarks'
      }
    ];
    this.rowHeight = 50;
    this.defaultColDefine = { resizable: true };
    this.detailCellRendererParams = {
      detailGridOptions: {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableRangeSelection: true,
        pagination: true,
        paginationAutoPageSize: true,
        columnDefs: [
          {
            field: 'Date'
          },
          { field: 'ActualStation' },
          {
            field: 'WorkingRoute',
            minWidth: 150,
          },
          {
            field: 'DAType'
          },
          {
            field: 'Work With'
          },
          {
            field: 'Call'
          },
          // {
          //   field: 'Mode'
          // },
          {
            field: 'KM'
          },
          {
            field: 'Fare (TA)'
          },
          {
            field: 'HQ/Ex/Out Station'
          },
          {
            field: 'OtherExpense'
          },
          {
            field: 'Total'
          },
          {
            field: 'Remarks'
          }
        ],
        rowHeight: 50,
        headerHeight: 50,
        defaultColDef: {
          sortable: true,
          flex: 1,
        },
      },
      getDetailRowData: function (params) {
        console.log('params', params.data.details);
        params.successCallback(params.data.details);
      },
    };
  }

  onFirstDataRendered(params) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1).setExpanded(false);
    }, 0);
  }

  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.chemistmasterdataModel.StateID = 0;
    this.chemistmasterdataModel.HQ = '0';
    this.chemistmasterdataModel.designation = "0";
    this.chemistmasterdataModel.status = "-1";
    this.getStaffTypes();
    // this.getExpDetails();
    var date = new Date();
    this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
    this.chemistmasterdataModel.designation = "0";
    this.chemistmasterdataModel.currentMonth = this.currentDate;
    //console.log('currentDate', this.currentMonth);
    this.getState();
    this.getHeadQuarterList();
    $('#filter-option').trigger('click');
    this.rowData = [];
  }

  getState() {
    this.apiService.getState().subscribe((res: any) => {
      this.stateList = res.data;
    })
  }

  getHeadQuarterList() {
    this.apiService.getHeadQuarterList().subscribe((res: any) => {
      this.headQuarterList = res.data;
    })
  }
  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();

  }

  onGridReady2 = (params) => {
    this.api2 = params.api;
    this.columnApi2 = params.columnApi;
  }



  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
  }

  getStaffTypes() {
    this.apiService.getStaffTypes().subscribe((res: any) => {
      this.staffTypes = res.data;
      console.log('stafftypes ', this.staffTypes);
    })
  }

  getExpDetails() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    //  console.log('token', token);
    var data = {
      Id: token.id
    };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.expDetails = res.data;
      console.log('empDetails', this.expDetails);
    })
  }

  filterData() {
    // console.log(this.chemistmasterdataModel);
    // var queryData = {
    //   staffId: this.staff ? this.staff.ClientTypeID : '',
    //   designationId: this.designation ? this.designation.ClientTypeID : '',
    //   date: this.currentMonth
    // }

    var queryData = {
      designationId: this.chemistmasterdataModel.designation,
      date: this.chemistmasterdataModel.currentMonth,
      HQ: this.chemistmasterdataModel.HQ,
      StateID: this.chemistmasterdataModel.StateID,
      status: this.chemistmasterdataModel.status,
      LoginId: this.token.id
    }
    // console.log(queryData);
    this.busy = this.apiService.getExpenseStmt(queryData).subscribe((res: any) => {
      var data = res;
      var expStmt = res.expStmt;
      this.rowData = res.expStmtDetails;
      var expStmtDetails = res.expStmtDetails;
      console.log('expStmt', expStmt);
      console.log('expStmtDetails', expStmtDetails);
      // console.log('expDetails ..', data);
      var arr: any;
      var data1: any = {};
      var arr2: any = [];
      expStmt.filter((el, index) => {
        data1 = el;
        arr = [];
        // debugger
        expStmtDetails.filter(data => {
          if (el.Client_Code === data.Client_Code) {
            arr.push(data);
          }
        })
        data1.details = arr;
        //   expStmt[index].details = arr;
        arr2.push(data1);
      })

      this.expDetails = arr2;

      console.log('arr2', arr2);

      this.staff = '';
      this.designation = '';
      this.currentMonth = this.currentDate
    })

    console.log('filterData ', queryData);
  }

  GetExpenseStmtForExport() {
    let Data = {
      designationId: this.chemistmasterdataModel.designation,
      date: this.chemistmasterdataModel.currentMonth,
      HQ: this.chemistmasterdataModel.HQ,
      StateID: this.chemistmasterdataModel.StateID,
      status: this.chemistmasterdataModel.status,
      LoginId: this.token.id
    }
    this.busy = this.apiService.GetExpenseStmtForExport(Data).subscribe((res: any) => {
      var exportdata = res.data;
      this.ExcelService.exportAsExcelFile(exportdata, 'Expense_Statement');
    })
  }
}
